import { type ButtonProps } from '@pets-ui/Button/Button'
import { Button } from '@pets-ui/Button/Button'
import { HelpOutlined } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  validateButton: {
    padding: '8px 12px',
    borderColor: colors.blue600,
    backgroundColor: {
      'default': 'none',
      '@media (hover: hover)': {
        'default': null,
        ':hover': 'none',
      },
    },
    color: colors.blue600,
    flexShrink: 0,
    textWrap: 'nowrap',
    height: '36px',
  },
  isBound: {
    color: colors.grey600,
  },
  tooltip: {
    backgroundColor: colors.white,
    textWrap: 'wrap',
  },
})

export interface ButtonBindProps extends ButtonProps {
  isBound: boolean
  canUnBind?: boolean
  text: string
}

export function ButtonBind(props: ButtonBindProps) {
  const { t } = useTranslation()
  const { isBound, canUnBind, text, onClick, ...rest } = props
  return (
    <Button
      variant={isBound ? 'text' : 'outlined'}
      rootStyle={[styles.validateButton, isBound && styles.isBound]}
      onClick={canUnBind ? onClick : undefined}
      {...rest}
    >
      {isBound
        ? canUnBind
          ? t('login.unbind')
          : (
            <Tooltip
              placement="bottom-end"
              title={(
                <Text
                  rootStyle={styles.tooltip}
                  variant="caption"
                >
                  {t('login.cnanotUnbindContext')}
                </Text>
              )}
            >
              <HelpOutlined color={colors.grey500} fontSize={20} />
            </Tooltip>
          )
        : text}
    </Button>
  )
}
